import md5 from 'md5'

export const getHashedEmail = (email: string | undefined | null) => {
    if (typeof email !== 'string' || !email) return undefined

    return md5(email)
}